import type * as DataViewModule from '@/pages/data-view';

/** `@/pages/data-view` 가 export 하는 페이지 컴포넌트 이름(…Page). 오타면 컴파일 오류가 난다. */
export type DataViewPageName = Extract<
  keyof typeof DataViewModule,
  `${string}Page`
>;

interface DataViewPageDef {
  /** 화면 경로. 메뉴 관리의 Path 와 정확히 같아야 한다(사이드바·MenuAccessGuard 가 완전 일치로 찾는다). */
  path: string;
  label: string;
  /** `@/pages/data-view` 의 export 이름 */
  page: DataViewPageName;
}

/**
 * 데이터 조회 화면 목록. 새 조회 화면은 페이지를 `@/pages/data-view` 에서 export 한 뒤 여기에 한 항목만 추가한다.
 * 라우트(RouterObject)와 Urls 항목이 이 목록에서 만들어진다.
 * 키는 기존 Urls 키와 같다 — Urls 가 Record<string, …> 라 키가 바뀌어도 컴파일 오류가 나지 않으므로 바꾸지 말 것.
 */
export const DATA_VIEW_PAGES = {
  dataViewPurchasePaymentJournal: {
    path: '/data-view/interface-db/purchase-payment-journal',
    label: '구매처 지급 분개장',
    page: 'PurchasePaymentJournalPage',
  },
  dataViewAccountDaily: {
    path: '/data-view/interface-db/account-daily',
    label: '입출금정보조회(원화)',
    page: 'AccountDailyTransactionPage',
  },
  dataViewInsideBankFx: {
    path: '/data-view/interface-db/inside-bank-fx',
    label: '입출금정보조회(외화)',
    page: 'InsideBankFxPage',
  },
  dataViewSweepExecution: {
    path: '/data-view/interface-db/sweep-execution',
    label: '입출금정보조회(집금)',
    page: 'SweepExecutionPage',
  },
  dataViewDeliveryOrderLine: {
    path: '/data-view/byod/delivery-order-line',
    label: '배송오더 라인 조회',
    page: 'DeliveryOrderLinePage',
  },
  dataViewSalesInvoiceLine: {
    path: '/data-view/byod/sales-invoice-line',
    label: '매출송장조회(SW개발)',
    page: 'SalesInvoiceLinePage',
  },
  dataViewCustomerMaster: {
    path: '/data-view/byod/customer-master',
    label: '고객 마스터 조회',
    page: 'CustomerMasterPage',
  },
  dataViewDhr: {
    path: '/data-view/byod/dhr',
    label: 'Device History Report',
    page: 'DhrPage',
  },
  dataViewSalesOrderInquiry: {
    path: '/data-view/odata/sales-order-inquiry',
    label: '판매주문 조회',
    page: 'SalesOrderInquiryPage',
  },
  dataViewDoRegistrationStatus: {
    path: '/data-view/odata/do-registration-status',
    label: 'DO 등록 현황 조회',
    page: 'DeliveryOrderSourceLinePage',
  },
  dataViewPendingDeliveryOrder: {
    path: '/data-view/odata/pending-delivery-orders',
    label: '출고 대기 배송오더 조회',
    page: 'PendingDeliveryOrderPage',
  },
  dataViewCardExpense: {
    path: '/data-view/interface-db/card-expense',
    label: '법인카드 사용내역 조회',
    page: 'CardExpensePage',
  },
  dataViewSalesShipment: {
    path: '/data-view/odata/sales-shipments',
    label: '판매출고 조회',
    page: 'SalesShipmentPage',
  },
} as const satisfies Record<string, DataViewPageDef>;
